import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { ClearGroup, ClearGroupBtn } from './theme';
const ClearGroupFilter = ({text, clearFilterHandler}) => {
  const history = useHistory();
  const { pathname } = useLocation();


  const resetSearchParams = () => {
    history.push({
      pathname,
      search: '', 
    });
    clearFilterHandler && clearFilterHandler();
  }


  return (
    <ClearGroup>
      {text}
      <ClearGroupBtn onClick={resetSearchParams}>clear filter</ClearGroupBtn>
    </ClearGroup>
  )
}

export default ClearGroupFilter